@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/sizes";

// The row holding the <label> and, when there is one, its tooltip icon as a sibling. Consumer
// `className` lands here, so typography stays on this element and reaches the text by inheritance;
// declared on the <label> it would beat whatever a consumer set out here.
.root {
  display: inline-flex;
  align-items: center;
  gap: sizes.$s3;
  width: fit-content;
  color: var(--label-text-color, var(--text-color));
  font-size: var(--label-font-size, fonts.$mid);
  font-weight: fonts.$book;
  // Prevent text selection when double clicking
  user-select: none;

  // Hover and cursor key off the <label>, not the row: the tooltip icon is a sibling, and
  // hovering it should not tint the label text or claim the label's pointer.
  .label:hover {
    color: var(--label-text-color-hover, var(--text-color));
  }

  &.disabled .label {
    color: var(--disabled-text-color, var(--secondary-text-color));
    cursor: not-allowed;
  }

  &.clickable .label {
    cursor: pointer;
  }
}

// The semantic element. The row owns typography and spacing, so this only needs to wrap its
// content tightly rather than introduce a second box around it.
.label {
  display: inline-flex;
  min-width: 0;
}

.content {
  display: flex;
  align-items: center;
  gap: sizes.$s3;
  width: fit-content;
}

.tooltipIconWrapper {
  display: inline-flex;
  flex-shrink: 0;
  border-radius: sizes.$s2;
  cursor: help;
}

.tooltipIcon {
  flex-shrink: 0;
  color: var(--secondary-text-color);
  cursor: help;
  width: 1.2em;
  height: 1.2em;
  transition: color 0.2s ease;

  &:hover {
    color: var(--text-color);
  }
}

.requiredIndicator {
  color: var(--required-indicator-color, colors.$red);
}
